/** @format */
import { DrawerProps } from '@mpb-com/feather/components/molecules/drawer';
import { Context, ReactNode, createContext } from 'react';

import { ModalSize, ModalVariant } from '@toucan/client/global/application';

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type BlackoutContextProps = {
    // eslint-disable-next-line @typescript-eslint/naming-convention -- Legacy code: do not use as an example.
    visible: boolean;
};

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type AdditionalHeaderContextProps = {
    start?: number;
    end?: number;
};

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export enum ScrollLock {
    MODAL = 'modal',
    TYPEAHEAD = 'typeahead',
    // We also have a drawer in the application context but the scroll lock is handled internally
}

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type ModalContextProps = {
    // eslint-disable-next-line @typescript-eslint/naming-convention -- Legacy code: do not use as an example.
    visible: boolean;
    content: ReactNode;
    size: ModalSize;
    closeLabel: string;
    isClosable: boolean;
    onClose?: () => void;
    variant?: ModalVariant;
};

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type LegalLinksContextProps = Record<
    string,
    {
        urlSlug: string;
    }
>;

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type ModalOptions = Partial<
    Pick<
        ModalContextProps,
        'size' | 'closeLabel' | 'isClosable' | 'onClose' | 'variant'
    >
>;

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type ApplicationContextProps = {
    stickyFooterHeight: number;
    setStickyFooterHeight: (arg: number) => void;
    // eslint-disable-next-line @typescript-eslint/naming-convention -- Legacy code: do not use as an example.
    userAgentDetectedAsBot: boolean;
    blackout: BlackoutContextProps;
    modal: ModalContextProps;
    drawer: DrawerProps;
    additionalHeaderDisplayBoundary: AdditionalHeaderContextProps;
    legalLinks: LegalLinksContextProps;
    setBlackoutVisible: (arg: boolean) => void;
    setModalVisible: (arg: boolean, options?: ModalOptions) => void;
    setModalContent: (arg: ReactNode) => void;
    setModalSize: (arg: ModalSize) => void;
    setModalCloseLabel: (label: string) => void;
    openDrawer: (drawer: Omit<DrawerProps, 'open'>) => void;
    closeDrawer: () => void;
    addPageScrollLock: (lock: ScrollLock, selectors?: string[]) => void;
    removePageScrollLock: (lock: ScrollLock, selectors?: string[]) => void;
    setAdditionalHeaderDisplayBoundary: ({
        start,
        end,
    }: AdditionalHeaderContextProps) => void;
};

export const ApplicationContext: Context<ApplicationContextProps> =
    createContext({} as ApplicationContextProps);

ApplicationContext.displayName = 'ApplicationContext';
